import { createCachedSelector } from 're-reselect';

import getWindowWidth from '@/state/selectors/window/get-window-width';
import { IStore } from '@/state/slices/typings';

const getMaxBreakpointLowerThan = createCachedSelector(
	[getWindowWidth, (_: IStore, breakpointsKeys: number[]) => breakpointsKeys],
	(windowWidth, breakpointsKeys) => {
		const breakpointsLowerThan = breakpointsKeys.filter(
			(breakpointsKey) => windowWidth >= breakpointsKey,
		);
		const maxBreakpoint = Math.max(...breakpointsLowerThan);
		if (maxBreakpoint === -Infinity) {
			return 0;
		}
		return maxBreakpoint;
	},
)((_: IStore, breakpointsKeys: number[]) => breakpointsKeys.join('_'));

export default getMaxBreakpointLowerThan;
